import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Meta from 'vue-meta'

// landing
import LandingPage from './views/landing/index.vue'
// admin routes
import AdminClientsRoutes from '@/views/admin/clients/routes.js'
import AdminFundisRoutes from '@/views/admin/fundis/routes.js'
import AdminSonkosRoutes from '@/views/admin/sonkos/routes.js'
import AdminCategoriesRoutes from '@/views/admin/categories/routes.js'
import AdminSubscriptionRoutes from '@/views/admin/subscription/routes.js'
import AdminSmsRoutes from '@/views/admin/sms/routes.js'
import AdminFaqRoutes from '@/views/admin/faqs/routes.js'
import AdminSettingsRoutes from '@/views/admin/settings/routes.js'
import AdminJobsRoutes from '@/views/admin/jobs/routes.js'
import AdminProjectsRoutes from '@/views/admin/projects/routes.js'
import AdminLoginRoutes from '@/views/admin/login/routes.js'
import AdminEditorsRoutes from '@/views/admin/editors/routes.js'
import AdminManagersRoutes from '@/views/admin/managers/routes.js'
import AdminProjectRatingsRoutes from '@/views/admin/projectratings/routes.js'
import AdminExpertRatingsRoutes from '@/views/admin/expertratings/routes.js'
import AdminProfileRoutes from '@/views/admin/profile/routes.js'
import AdminBlogsRoutes from '@/views/admin/blogs/routes.js'
import AdminBlogCommentsRoutes from '@/views/admin/blogcomments/routes.js'
import AdminDonationsRoutes from '@/views/admin/donations/routes.js'
import AdminWorkshopsRoutes from '@/views/admin/workshops/routes.js'
import AdminVIPSonkosRoutes from '@/views/admin/vip_sonkos/routes.js'

// fundi routes
import RegistrationRoutes from '@/views/registration/routes.js'
import LoginRoutes from '@/views/login/routes.js'
import ExpertLandingRoutes from '@/views/expert/landing/routes.js'
import ExpertProjectsRoutes from '@/views/expert/projects/routes.js'
import ExpertJobsRoutes from '@/views/expert/assigned_jobs/routes.js'
import ExpertProfileRoutes from '@/views/expert/profile/routes.js'
import NewJobsRoutes from '@/views/expert/new_jobs/routes.js'
import ExpertPaymentRoutes from '@/views/expert/payments/routes.js'
import ExpertReviewsRoutes from '@/views/expert/reviews/routes.js'
import AllJobsRoutes from '@/views/expert/jobs/routes.js'
// sonko routes
import SonkoLandingRoutes from '@/views/sonko/landing/routes.js'
import SonkoJobsRoutes from '@/views/sonko/jobs/routes.js'
import SonkoProfileRoutes from '@/views/sonko/profile/routes.js'
import AllExpertsRoutes from '@/views/sonko/experts/routes.js'
// packages
import ValidationRoutes from '@/views/validation/routes.js'
import { AdminGuard, EditorGuard, ManagerGuard } from '@/common/guard'
import NotFound from './components/404.vue'
import TicketsRoutes from '@/views/tickets/routes.js'
import AdminTicketsRoutes from '@/views/admin/ticketreplies/routes.js'
import ExpertTicketsRoutes from '@/views/expert/tickets/routes.js'
// vip sonko routes
import VIPSonkoLandingRoutes from '@/views/vip_sonko/landing/routes.js'
import VIPSonkoJobsRoutes from '@/views/vip_sonko/jobs/routes.js'
import VIPSonkoProfileRoutes from '@/views/vip_sonko/profile/routes.js'
import VIPAllExpertsRoutes from '@/views/vip_sonko/experts/routes.js'
import VIPSonkoTicketsRoutes from '@/views/vip_sonko/tickets/routes.js'
import VIPSonkoPackagesRoutes from '@/views/vip_sonko/packages/routes.js'
import VIPSonkoPaymentRoutes from '@/views/vip_sonko/payments/routes.js'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: LandingPage
    },
    {
      path: '/dashboard',
      beforeEnter: EditorGuard,
      name: 'home',
      component: Home
    },
    ...AdminClientsRoutes,
    ...AdminFundisRoutes,
    ...AdminSonkosRoutes,
    ...AdminCategoriesRoutes,
    ...AdminSubscriptionRoutes,
    ...AdminSmsRoutes,
    ...AdminFaqRoutes,
    ...AdminSettingsRoutes,
    ...AdminJobsRoutes,
    ...AdminProjectsRoutes,
    ...AdminLoginRoutes,
    ...AdminEditorsRoutes,
    ...AdminManagersRoutes,
    ...AdminProjectRatingsRoutes,
    ...AdminExpertRatingsRoutes,
    ...AdminProfileRoutes,
    ...AdminBlogsRoutes,
    ...AdminBlogCommentsRoutes,
    ...AdminDonationsRoutes,
    // authentication routes
    ...RegistrationRoutes,
    ...LoginRoutes,
    // fundi routes
    ...ExpertLandingRoutes,
    ...ExpertProjectsRoutes,
    ...ExpertJobsRoutes,
    ...ExpertProfileRoutes,
    ...ExpertPaymentRoutes,
    ...ExpertReviewsRoutes,
    ...AllJobsRoutes,
    ...NewJobsRoutes,
    // sonko routes
    ...SonkoLandingRoutes,
    ...SonkoJobsRoutes,
    ...SonkoProfileRoutes,
    ...ValidationRoutes,
    ...AllExpertsRoutes,
    ...TicketsRoutes,
    ...AdminTicketsRoutes,
    ...ExpertTicketsRoutes,
    ...AdminWorkshopsRoutes,
    ...VIPSonkoProfileRoutes,
    ...VIPSonkoLandingRoutes,
    ...VIPSonkoJobsRoutes,
    ...VIPAllExpertsRoutes,
    ...VIPSonkoTicketsRoutes,
    ...VIPSonkoPackagesRoutes,
    ...AdminVIPSonkosRoutes,
    ...VIPSonkoPaymentRoutes,
    { path: '*', component: NotFound }
  ]
})
